/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Field } from "./Field";
import * as t from "io-ts";

/**
 * Form fields for credit cards
 */

// required attributes
const CardFormFieldsR = t.interface({
  paymentMethod: t.string,

  form: t.readonlyArray(Field, "array of Field")
});

// optional attributes
const CardFormFieldsO = t.partial({});

export const CardFormFields = t.intersection(
  [CardFormFieldsR, CardFormFieldsO],
  "CardFormFields"
);

export type CardFormFields = t.TypeOf<typeof CardFormFields>;
